import { Checkbox } from 'antd';
import { Privilege } from '../../../shared/RoleBasedTypes';
import { FEATURE_PRIVILEGES } from './FeaturePrivileges';
import { PRIVILEGE_DISPLAY_MAP } from './PrivilegeDisplayMap';
import {
	RoleBasedModules,
	UserRole,
} from '../../../shared/VolunteerApplicationServiceTypes';
import { PrivilegeCodes } from '../../../shared/RoleConstants';

interface Props {
	privileges: Privilege[];
	selectedPrivilegeIds: number[];
	onChange: (ids: number[]) => void;
	moduleCode?: string;
	roleCode?: string;
}

export const FeaturePrivilegeMatrix = ({
	privileges,
	selectedPrivilegeIds,
	onChange,
	moduleCode,
	roleCode,
}: Props) => {
	const privilegeMap = new Map(privileges.map((p) => [p.code, p]));

	const togglePrivilege = (privilegeId: number, checked: boolean) => {
		let updated: number[];

		if (checked) {
			updated = [...selectedPrivilegeIds, privilegeId];
		} else {
			updated = selectedPrivilegeIds.filter((id) => id !== privilegeId);
		}

		onChange(updated);
	};

	return (
		<div className="flex flex-col gap-8">
			{FEATURE_PRIVILEGES.map((feature) => {
				const featurePrivileges = feature.privilegeCodes
					.map((code) => privilegeMap.get(code))
					.filter(Boolean) as Privilege[];

				const nonDefaultPrivileges = featurePrivileges.filter((privilege) => {
					const privilegeLabel =
						PRIVILEGE_DISPLAY_MAP[privilege.code] ?? privilege.name;

					if (
						moduleCode === RoleBasedModules.PREWORK_MODULE &&
						privilegeLabel === 'View New Preceptors List'
					) {
						return false;
					}
					if (
						roleCode === UserRole.PROPOSER &&
						[
							'View Screening Dashboard',
							'Proposer Reassign',
							'Update Region/Zone/Center of Application',
							'View Proposer Load',
							'View Zones Proposer Load',
							'View Candidate Load',
							'Bulk assign for region',
							'View Central Team Dashboard',
						].includes(privilegeLabel)
					) {
						return false;
					}
					if (
						roleCode !== UserRole.APPROVER &&
						[
							PrivilegeCodes.GET_PREWORK_APPLICATIONS,
							PrivilegeCodes.CAPTURE_PREWORK_MENTOR_ANSWERS,
						].includes(privilege.code)
					) {
						return false;
					}
					return !privilege.isDefault;
				});

				if (!nonDefaultPrivileges.length) return null;
				return (
					<div key={feature.feature}>
						{/* Feature title */}
						<div className="font-semibold text-lg mb-3">{feature.feature}</div>

						{/* Privilege list */}
						<div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
							{nonDefaultPrivileges.map((privilege) => {
								const checked = selectedPrivilegeIds.includes(privilege.id);

								return (
									<Checkbox
										key={privilege.id}
										checked={checked}
										onChange={(e) =>
											togglePrivilege(privilege.id, e.target.checked)
										}
									>
										{PRIVILEGE_DISPLAY_MAP[privilege.code] ?? privilege.name}
									</Checkbox>
								);
							})}
						</div>
					</div>
				);
			})}
		</div>
	);
};
